/* ChatListItem.tsx generated by @compiled/babel-plugin v2.0.0 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._30huDKjg0e%7Bborder%3Avar(--ds-border-width%2C1px)%20solid%20transparent%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2mHwu81Y8M%7Bgap%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02N91d%7Bwidth%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0hPCNLDIqT%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2O5Vij7dHp%7Bflex-grow%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3138424F84%7Bmargin-top%3Avar(--ds-space-negative-100%2C-8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2sNsIgmnOE%7Bfont%3Avar(--ds-font-body%2Cnormal%20400%2014px%2F20px%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._30huDKS6k6%7Bborder%3Avar(--ds-border-width%2C1px)%20solid%20var(--ds-border-input%2C%238c8f97)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDKxmn%7Bborder-radius%3Avar(--ds-radius-small%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2xIroY98eZ%7Boutline-color%3AcurrentColor%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._497WNwYbGa%7Boutline-style%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2zndICT6kp%7Boutline-width%3Amedium%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._24h04i2Njc%7Bbox-sizing%3Aborder-box%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1kk5Tkf7mX%7Bfont-weight%3Avar(--ds-font-weight-medium%2C500)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Of8r21Y8M%7Bpadding-top%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ZnuxbgVvo%7Bpadding-right%3Avar(--ds-space-075%2C6px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1wydGW1Y8M%7Bpadding-bottom%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2Zuz6Q1Y8M%7Bpadding-left%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0xkEdpnXvL%3Afocus%7Bborder-color%3Avar(--ds-border-focused%2C%234688ec)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0ui43C2Bgz%3Afocus%7Bbox-shadow%3A0%200%200%20var(--ds-border-width%2C1px)%20var(--ds-border-focused%2C%234688ec)%7D");
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { bind } from 'bind-event-listener';
import { useIntl } from 'react-intl';
import IconButton from '@atlaskit/button/icon/button';
import Field from '@atlaskit/form/field';
import Form from '@atlaskit/form/form';
import CheckMarkIcon from '@atlaskit/icon/core/check-mark';
import CrossIcon from '@atlaskit/icon/core/cross';
import DeleteIcon from '@atlaskit/icon/core/delete';
import EditIcon from '@atlaskit/icon/core/edit';
import MoreIcon from '@atlaskit/icon/core/show-more-horizontal';
import ButtonItem from '@atlaskit/menu/button-item';
import MenuGroup from '@atlaskit/menu/menu-group';
import { Popup } from '@atlaskit/popup/popup';
import { Box } from '@atlaskit/primitives/compiled';
import defaultMessages from './messages';
import type { ChatListItemProps } from './types';
const POPUP_Z_INDEX = 600;
const styles = {
  renameForm: "_30huDKjg0e _3iDTPbQ4SZ",
  innerForm: "_2mHwu81Y8M _39xV02N91d _3iDTPbQ4SZ _0hPCNLDIqT",
  textFieldContainer: "_2O5Vij7dHp _3138424F84",
  textField: "_2sNsIgmnOE _30huDKS6k6 _0bjKvDKxmn _2xIroY98eZ _497WNwYbGa _2zndICT6kp _39xV02N91d _24h04i2Njc _1kk5Tkf7mX _0Of8r21Y8M _1ZnuxbgVvo _1wydGW1Y8M _2Zuz6Q1Y8M _0xkEdpnXvL _0ui43C2Bgz"
};
export const ChatListItem = ({
  id,
  name,
  titleSuffix,
  elemBefore,
  description,
  elemAfter,
  isSelected,
  size,
  onSelect,
  onRename,
  onDelete,
  moreMenuItems,
  isMoreMenuOpen: isMoreMenuOpenProp,
  onMoreMenuOpenChange,
  renderContainer,
  afterContent,
  testId = 'chat-list-item',
  renameLabel: renameLabelProp,
  deleteLabel: deleteLabelProp,
  moreButtonLabel: moreButtonLabelProp,
  renameInputLabel: renameInputLabelProp,
  confirmRenameLabel: confirmRenameLabelProp,
  cancelRenameLabel: cancelRenameLabelProp
}: ChatListItemProps): React.JSX.Element => {
  const {
    formatMessage
  } = useIntl();
  const [uncontrolledIsMoreMenuOpen, setUncontrolledIsMoreMenuOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [localName, setLocalName] = useState(name);
  const [usingLocalName, setUsingLocalName] = useState(false);
  const [shouldRestoreFocusToMoreButton, setShouldRestoreFocusToMoreButton] = useState(false);
  const formRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const moreButtonRef = useRef<HTMLButtonElement | null>(null);
  const isMoreMenuOpen = isMoreMenuOpenProp ?? uncontrolledIsMoreMenuOpen;
  const wasMoreMenuOpenRef = useRef(isMoreMenuOpen);
  const setIsMoreMenuOpen = useCallback((nextIsOpen: boolean) => {
    if (isMoreMenuOpenProp === undefined) {
      setUncontrolledIsMoreMenuOpen(nextIsOpen);
    }
    onMoreMenuOpenChange?.(nextIsOpen);
  }, [isMoreMenuOpenProp, onMoreMenuOpenChange]);

  // ── Resolved labels ──────────────────────────────────────────────────

  const resolvedRenameLabel = renameLabelProp ?? formatMessage(defaultMessages.moreMenuRenameLabel);
  const resolvedDeleteLabel = deleteLabelProp ?? formatMessage(defaultMessages.moreMenuDeleteLabel);
  const resolvedMoreBtnLabel = moreButtonLabelProp ?? formatMessage(defaultMessages.moreBtnLabel);
  const resolvedRenameInputLabel = renameInputLabelProp ?? formatMessage(defaultMessages.renameInputLabel);
  const resolvedConfirmRenameLabel = confirmRenameLabelProp ?? formatMessage(defaultMessages.confirmRenameLabel);
  const resolvedCancelRenameLabel = cancelRenameLabelProp ?? formatMessage(defaultMessages.cancelRenameLabel);

  // ── More-menu handlers ───────────────────────────────────────────────

  const handleToggleMoreMenu = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    moreButtonRef.current = event.currentTarget;
    setIsMoreMenuOpen(!isMoreMenuOpen);
  }, [isMoreMenuOpen, setIsMoreMenuOpen]);
  const handleCloseMoreMenu = useCallback(() => {
    setIsMoreMenuOpen(false);
  }, [setIsMoreMenuOpen]);
  useEffect(() => {
    const wasMoreMenuOpen = wasMoreMenuOpenRef.current;
    wasMoreMenuOpenRef.current = isMoreMenuOpen;

    /* eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- legacy onboarding baseline */
    if (wasMoreMenuOpen && !isMoreMenuOpen && document.activeElement === document.body) {
      moreButtonRef.current?.focus();
    }
  }, [isMoreMenuOpen]);
  const onRenameBtnClicked = useCallback(() => {
    setIsMoreMenuOpen(false);
    setLocalName(name);
    setIsEditing(true);
  }, [name, setIsMoreMenuOpen]);
  const onDeleteBtnClicked = useCallback(() => {
    setIsMoreMenuOpen(false);
    // Seed modal return-focus target with the originating "More" trigger.
    moreButtonRef.current?.focus();
    onDelete?.();
  }, [onDelete, setIsMoreMenuOpen]);

  // ── Rename handlers ──────────────────────────────────────────────────

  const isMountedRef = useRef(true);
  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  const onSubmitRename = useCallback(async (value: string) => {
    const prevName = localName;
    setIsEditing(false);
    setLocalName(value);
    setUsingLocalName(true);
    const result = await onRename?.(value);
    if (!isMountedRef.current) {
      return;
    }
    if (result && 'error' in result) {
      // On error, revert and return authority to the parent prop immediately
      setLocalName(prevName);
      setUsingLocalName(false);
    }
  }, [localName, onRename]);
  const onCancelRename = useCallback(() => {
    setShouldRestoreFocusToMoreButton(true);
    setIsEditing(false);
  }, []);

  // Sync external name prop changes → localName.
  // While usingLocalName is true (optimistic rename in flight), we trust our local value.
  // Once the parent prop catches up to our local value, we hand authority back to the parent.
  useEffect(() => {
    if (!usingLocalName) {
      setLocalName(name);
    } else if (name === localName) {
      // Parent confirmed the rename — hand authority back
      setUsingLocalName(false);
    }
  }, [name, usingLocalName, localName]);

  // Focus the input when editing starts
  useEffect(() => {
    if (!isEditing) {
      return;
    }
    inputRef.current?.focus();
  }, [isEditing]);

  // Restore focus to the more button after rename cancel
  useEffect(() => {
    if (isEditing || !shouldRestoreFocusToMoreButton) {
      return;
    }
    setShouldRestoreFocusToMoreButton(false);
    // Explicitly call .focus() — autoFocus alone is not reliable across all
    // IconButton implementations.
    moreButtonRef.current?.focus();
  }, [isEditing, shouldRestoreFocusToMoreButton]);

  // Close the rename form when the user clicks outside
  useEffect(() => {
    if (!isEditing) {
      return;
    }
    const handleClickOutside = (event: Event) => {
      if (formRef.current && !formRef.current.contains((event.target as Node))) {
        onCancelRename();
      }
    };
    const unbind = bind(window, {
      type: 'mousedown',
      listener: handleClickOutside,
      options: {
        capture: true
      }
    });
    return unbind;
  }, [isEditing, onCancelRename]);

  // ── Determine if more menu should show ───────────────────────────────

  const hasMoreMenu = Boolean(onRename || onDelete || moreMenuItems);

  // ── More-menu popup ──────────────────────────────────────────────────

  const moreMenu = hasMoreMenu ? <Popup testId={`${testId}-more-popup`} isOpen={isMoreMenuOpen} onClose={handleCloseMoreMenu} zIndex={POPUP_Z_INDEX} content={() => <MenuGroup>
					{onRename && <ButtonItem testId={`${testId}-rename`} iconBefore={<EditIcon label="" />} onClick={onRenameBtnClicked}>
							{resolvedRenameLabel}
						</ButtonItem>}
					{moreMenuItems}
					{onDelete && <ButtonItem testId={`${testId}-delete`} iconBefore={<DeleteIcon label="" color={"var(--ds-icon-danger, #C9372C)"} />} onClick={onDeleteBtnClicked}>
							{resolvedDeleteLabel}
						</ButtonItem>}
				</MenuGroup>} trigger={triggerProps => <IconButton {...triggerProps} autoFocus={shouldRestoreFocusToMoreButton} testId={`${testId}-more`} icon={() => <MoreIcon label="" size="small" />} appearance="subtle" spacing="compact" onClick={handleToggleMoreMenu} label={resolvedMoreBtnLabel} />} placement="bottom-end" /> : null;

  // ── Rename form ──────────────────────────────────────────────────────

  const renameForm = <div ref={formRef} className={ax([styles.renameForm])}>
			<Form onSubmit={(data: {
      chatName: string;
    }) => {
      onSubmitRename(data.chatName);
    }} formProps={{
      class: styles.innerForm
    }}>
				<Box xcss={styles.textFieldContainer}>
					<Field name="chatName" defaultValue={localName}>
						{({
            fieldProps
          }) => <input {...fieldProps} ref={inputRef} aria-label={resolvedRenameInputLabel} onKeyDown={(e: React.KeyboardEvent) => {
            if (e.key === 'Escape') {
              onCancelRename();
            }
          }} data-testid={`${testId}-name-edit`} className={ax([styles.textField])} />}
					</Field>
				</Box>
				<IconButton icon={iconProps => <CheckMarkIcon {...iconProps} color={"var(--ds-icon-accent-green, #22A06B)"} />} type="submit" appearance="subtle" shape="circle" spacing="compact" label={resolvedConfirmRenameLabel} testId={`${testId}-rename-confirm`} />
				<IconButton icon={iconProps => <CrossIcon {...iconProps} color={"var(--ds-icon-accent-red, #C9372C)"} />} type="button" onClick={onCancelRename} appearance="subtle" shape="circle" spacing="compact" label={resolvedCancelRenameLabel} testId={`${testId}-rename-cancel`} />
			</Form>
		</div>;

  // ── Render ────────────────────────────────────────────────────────────

  if (isEditing) {
    return renameForm;
  }
  const displayName = usingLocalName ? localName : name;
  return <>
			{renderContainer({
      children: displayName,
      titleSuffix,
      elemBefore,
      description,
      elemAfter,
      actionsOnHover: moreMenu ?? undefined,
      isSelected,
      onClick: onSelect,
      size,
      testId
    })}
			{afterContent}
		</>;
};